var ColumnConfiguration	= require('../binding/ColumnConfiguration'),
	ReferenceNode		= require('./ReferenceNode'),
	SharedStrings		= require('../data/SharedStrings'),
	Sheet				= require('../data/Sheet'),
	Styles				= require('../style/Styles');

/**
 * This class represents the workbook.xml file within the generated
 * Office Open XML Spreadsheet. The workbook is the central element
 * of the Office Open XML Spreadsheet that references all the content.
 *
 * @constructor
 */
function Workbook() {
	var key;

	ReferenceNode.call(this, Workbook.metadata);

	/* Create and register central Styles instance for this workbook */
	this._styles = new Styles();
	this._styles.setPath(this.getPath());
	this.addRelatedFile(this._styles);

	/* Create and register central SharedStrings instance for this workbook */
	this._sharedStrings = new SharedStrings();
	this._sharedStrings.setPath(this.getPath());
	this.addRelatedFile(this._sharedStrings);

	for (key in Workbook.RELATIONS) {
		this._relationships.addRelationship(Workbook.RELATIONS[key].target, Workbook.RELATIONS[key].type);
	}

	this._registeredSheets = [];
}

Workbook.prototype = Object.create(ReferenceNode.prototype);
Workbook.prototype.constructor = Workbook;

Workbook.RELATIONS = {
	sharedStrings: {
		target: 'sharedStrings.xml',
		type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings'
	},
	styles: {
		target: 'styles.xml',
		type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles'
	}
};

Workbook.metadata = {
	filename: 'workbook.xml',
	path: 'xl/',
	tag: 'workbook',
	root: true,
	attributes: [
		{
			name: 'xmlns',
			value: 'http://schemas.openxmlformats.org/spreadsheetml/2006/main'
		},
		{
			name: 'xmlns',
			suffix: 'r',
			value: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships'
		},
		{
			name: 'xmlns',
			suffix: 'mc',
			value: 'http://schemas.openxmlformats.org/markup-compatibility/2006'
		}
	],
	properties: [
		{
			tag: 'bookViews',
			properties: [
				{
					tag: 'workbookView',
					attributes: [
						{
							name: 'xWindow',
							value: '0'
						},
						{
							name: 'yWindow',
							value: '0'
						},
						{
							name: 'windowWidth',
							value: '22260'
						},
						{
							name: 'windowHeight',
							value: '12645'
						}
					]
				}
			]
		},
		{
			id: 'sheets',
			tag: 'sheets'
		},
		{
			id: 'definedNames',
			tag: 'definedNames'
		}
	]
};

/**
 * Adds a new {@link Sheet} to this {@link Workbook}
 *
 * @param {string} sName - Name of the {@link Sheet} that is used as label in Microsoft Excel
 * @param {Object} oConfig - The column configuration of this Sheet
 * @param {Array} oConfig.columns - Array containing the configuration for each column
 * @param {boolean} [oConfig.bHideHeader] - Hides the header row (optional - default: false)
 * @returns {Sheet} - The newly added {@link Sheet}
 */
Workbook.prototype.addSheet = function(sName, oConfig) {
	var oColumnConfiguration, nCount, sId, oSheet, sSheetFileName;

	nCount = this.sheets.childs.length + 1;
	sSheetFileName = 'sheet' + nCount + '.xml';
	sId = this._relationships.addRelationship('worksheets/' + sSheetFileName,
		'http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet');

	this.sheets.addChild({
		tag: 'sheet',
		attributes: [
			{
				id: 'name',
				name: 'name',
				value: sName
			},
			{
				name: 'sheetId',
				value: '' + nCount
			},
			{
				name: 'id',
				prefix: 'r',
				value: sId
			}
		]
	});

	oColumnConfiguration = new ColumnConfiguration(oConfig, this._sharedStrings, this._styles);
	oSheet = new Sheet(oColumnConfiguration);
	oSheet.setFileName(sSheetFileName);
	oSheet.setPath(this.getPath() + 'worksheets/');

	this.addRelatedFile(oSheet);
	this._registeredSheets.push(oSheet);

	return oSheet;
};

/**
 * Set the given sheet as selected. Unselects all other sheets in the workbook.
 *
 * @param {Sheet} oSheet - The Sheet object that should be selected
 */
Workbook.prototype.selectSheet = function(oSheet) {

	if (!(oSheet instanceof Sheet) || this._registeredSheets.indexOf(oSheet) < 0) {
		throw new Error('Could not select sheet. Sheet not found.');
	}

	/* Remove selection on all sheets */
	this._registeredSheets.forEach(function(sheetElement, index, array) {
		sheetElement.views.defaultView.remove('selected');
	});

	/* Select the particular Sheet */
	oSheet.views.defaultView.addAttribute({
		id: 'selected',
		name: 'tabSelected',
		value: '1' // Refers to W3C XML Schema boolean (true)
	});
};

/**
 * Registers definedNames for sheets that use autoFilter
 * functionality before processing the super class serialization.
 *
 * @returns {string} - The serialized String representation of this workbook
 */
Workbook.prototype.serialize = function() {
	var that = this;

	/**
	 * Creates the value for the definedName. It automatically
	 * retrieves the dimension of the sheet that is used by the
	 * filter and escapes its representation.
	 *
	 * @param {string} sSheetName - The title of the sheet
	 * @param {Sheet} oSheet - The sheet object containing the filter dimension
	 * @returns {string} - Escaped definedName value
	 * @private
	 */
	function createDefinedName(sSheetName, oSheet) {
		var sDefinedName, sDimension;

		sDimension = oSheet.filter.reference.value;
		sDefinedName = /^[a-zA-Z0-9]+$/.test(sSheetName) ? sSheetName : '\'' + sSheetName + '\'';
		sDefinedName += '!';
		sDefinedName += sDimension.replace(/([A-Z]+)|(\d+)/g, function(match) {
			return '$' + match;
		});

		return sDefinedName;
	}

	/* Create definedNames before serializing the workbook */
	this._registeredSheets.forEach(function(oSheet, iIndex, aArray) {
		var sSheetName = that.sheets.childs[iIndex].name.value;

		if (oSheet.filter) {
			that.definedNames.addChild({
				tag: 'definedName',
				attributes: [
					{
						name: 'name',
						value: '_xlnm._FilterDatabase'
					},
					{
						name: 'localSheetId',
						value: iIndex
					},
					{
						name: 'hidden',
						value: '1'
					}
				],
				value: createDefinedName(sSheetName, oSheet)
			});
		}
	});

	return Object.getPrototypeOf(Workbook.prototype).serialize.call(this);
};

module.exports = Workbook;


//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/objects/Workbook.js
// module id = 23
// module chunks = 0